<script setup lang="ts">
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from './PortfolioNavigation.vue'
    import DecisionNavigation from './DecisionNavigation.vue'

    // ---------------- props ----------------

    const props = defineProps<{
        workspaceId: number
        projectId: number
    }>()

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- derived ----------------

    // Detect type from URL path (hash or history mode safe)
    const solutionType = computed(() =>
    {
        const path = route.path.toLowerCase()

        if (path.startsWith('/portfolio'))
            return 'portfolio'

        if (path.startsWith('/decision'))
            return 'decision'

        return 'portfolio'
    })

    const navComponent = computed(() =>
        solutionType.value === 'portfolio'
            ? PortfolioNavigation
            : DecisionNavigation
    )
</script>


<template>
    <component :is="navComponent"
               :workspaceId="workspaceId"
               :projectId="projectId" />
</template>